'use strict'

Shopify.theme.jsFixedMessage = {
  init: function init($section) {
    if (window.navigator.userAgent.includes('PTST') || window.navigator.userAgent.includes('lighthouse')) {
      return
    }

    var _this = this

    this.$el = $('.fixed-message-section')
    var fixedMessageCookie = Cookies.get('fixed-message')

    if (fixedMessageCookie !== 'dismiss') {
      this.$el.removeClass('is-hidden') // Attach event to hide fixed message if button is clicked
      $(document.body).addClass('fixed-message--visible')

      const updateHeight = () => {
        const $bottomPurchase = $('.listing_product .product-form-container .purchase-details__buttons, .listing_product .product-form-container .out-stock-notify')
        if ($bottomPurchase.length) {
          $bottomPurchase.css('bottom', this.$el.height() + 'px')
        }
      }

      updateHeight()
      window.addEventListener('resize', updateHeight)

      $('.js-close-fixed-message').on('click', function () {
        window.removeEventListener('resize', updateHeight)
        _this.hide()
      })
    }
  },
  hide: function hide() {
    this.$el.addClass('is-hidden') // Remove fixed message and set cookie to hide it for 30 days

    const $bottomPurchase = $('.listing_product .product-form-container .purchase-details__buttons, .listing_product .product-form-container .out-stock-notify')
    if ($bottomPurchase.length) {
      $bottomPurchase.css('bottom', 0)
    }

    $(document.body).removeClass('fixed-message--visible')

    Cookies.set('fixed-message', 'dismiss', {
      expires: 30,
    })
  },
  unload: function unload($section) {
    // Clear event listeners in theme editor
    $('.js-close-fixed-message').off()
  },
}
